import { render } from "./prepagata.vue?vue&type=template&id=c0e5dbc8&bindings={\"navigate\":\"props\"}"
import script from "./prepagata.vue?vue&type=script&lang=js"
export * from "./prepagata.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./prepagata.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script